export default __webpack_public_path__ + "static/media/facial-recomendacao.f94ede43.png";